/* eslint-disable no-unused-vars */
import img from '../img/firstaction2startnow.svg';

export default {
  id: 'firstaction2startnow',
  img,
  imgBg: 'linear-gradient(to right, #C2F8FF 0%, #C2F8FF 50%, #FFDDBC 50%, #FFDDBC 100%)',
  defaultConf() {
    return {};
  },
  canRun({ planning, element, oldData, newData, automation }) {
    const oldCheckedCount = oldData.checklist?.filter(item => item.checked).length;
    const newCheckedCount = newData.checklist?.filter(item => item.checked).length;
    return ! oldCheckedCount && newCheckedCount;
  },
  run({ planning, element, oldData, newData, automation }, showToast) {
    if (showToast) showToast();
    const elementEndTime = element.getEndTime();
    if (element.hasDates()) {
      const duration = elementEndTime.diff(element.getStartTime());
      element.setEndTime(moment().add(duration, 'milliseconds'));
    } else if (elementEndTime && elementEndTime.isBefore(moment())) {
      element.setEndTime(moment().add(1, 'week'));
    }
    element.setStartTime(moment());
  },
};
